module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-9618.7eda110f.jpg";